import React, { Component } from 'react';

class RandomBlockOne extends Component{
  render(){
    return(
      <div className="random-block">
        <div className="random-block-border ellow">
          <div className="random-block-item">
            <div className="random-block-item-text">
              <div>
              <p className="random-block-title">За качество Отвечаем!</p>
              <p className="random-block-text">
                Мы собственноручно проверяем ткани на выходе с фабрик и гарантируем соответствие стандартам ISO. Брак не пройдёт!
              </p>
          </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default RandomBlockOne;
